import { render } from "./WorksHero.vue?vue&type=template&id=18660e8d&scoped=true"
const script = {}

import "./WorksHero.vue?vue&type=style&index=0&id=18660e8d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18660e8d"]])

export default __exports__